//component
import ListingTable from "../../../components/modal/listingTable";
import { Icon } from "@iconify/react";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";

export default function Listing({
  length,
  start,
  createAble,
  listingData,
  totalRecords,
  displayRecords,
  setSearch,
  setStartDate,
  setEndDate,
  setOrder,
  setLength,
  setStart,
  actionValue,
  handleActionChange,
  setHandleApplyFilter,
  getListing,
}) {
  const labelBodyTemplate = ({ ticket_name }) => {
    return (
      <MDBCol>
        <div className="template-group label-listing">{ticket_name}</div>
      </MDBCol>
    );
  };

  const badgeBodyTemplate = (rowData) => {
    let status = "";
    if (rowData.ticket_status == "waiting for payment") {
      status = "W.Payment";
    } else if (rowData.ticket_status == "pending") {
      status = "Pending";
    } else if (rowData.ticket_status == "booking") {
      status = "W.Booking";
    } else if (rowData.ticket_status == "use now") {
      status = "Reserved";
    } else if (rowData.ticket_status == "used") {
      status = "Used";
    } else if (rowData.ticket_status == "expired") {
      status = "Expired";
    }
    return <span className={`custom-badge status-${status}`}>{status}</span>;
  };

  const actionBodyTemplate = (options, { rowIndex }) => {
    return (
      <MDBRow className="action-button">
        <div
          style={{ width: "auto" }}
          onClick={() => {
            handleActionChange("information", options);
          }}
        >
          <Icon
            icon="heroicons:clipboard-document-list"
            color="#41B1CD"
            width="25"
            height="25"
          />
        </div>
      </MDBRow>
    );
  };

  const columns = [
    { selectionMode: "multiple", headerStyle: "3em" },
    { field: "transaction_id", header: "Transaction ID" },
    { field: "booking_id", header: "Booking ID" },
    { field: "ticket_type", header: "Ticket Type" },
    {
      field: "ticket_name",
      header: "Ticket Name",
      headerStyle: "5em",
      // body: labelBodyTemplate,
    },
    { field: "created_at", header: "Order Date & Time" },
    {
      field: "ticket_status",
      header: "Status",
      body: badgeBodyTemplate,
      //   filterElement: filterDateTemplate,
    },
    {
      field: "selected_at",
      header: "Participation Date",
      //   filterElement: filterDateTemplate,
    },
    { field: "sales_merchant", header: "Sales Merchant" },
    {
      field: "",
      header: "Details",
      body: actionBodyTemplate,
      headerStyle: "1em",
    },
  ];

  return (
    <div className="listing-container">
      <ListingTable
        title="Ticket Booking"
        data={listingData}
        columns={columns}
        createAble={createAble}
        setSearchValue={setSearch}
        setHandleApplyFilter={setHandleApplyFilter}
        setOrder={setOrder}
        length={length}
        start={start}
        setLength={setLength}
        setStart={setStart}
        totalRecords={totalRecords}
        displayRecords={displayRecords}
      />
    </div>
  );
}
